(function(){


function initProductSwitcher(){


    const cards = document.querySelectorAll(".product-card");


    if(!cards.length){

        console.log("没有产品");

        return;

    }



    const productInput = document.querySelector("#field-fWToYDjvYu");

    const sizeSelect = document.querySelector("#field-goZGmJeRAR");



    console.log(
        "product:",
        productInput
    );


    console.log(
        "size:",
        sizeSelect
    );



    if(!sizeSelect){

        console.log("Size还没有加载");

        return false;

    }




    function fireChange(el){


        [
            "input",
            "change"
        ].forEach(function(type){


            el.dispatchEvent(
                new Event(type,{
                    bubbles:true
                })
            );


        });


    }







    function loadProduct(card){



        console.log(
            "选择:",
            card.dataset.nameCn
        );



        cards.forEach(function(item){

            item.classList.remove("active");

        });


        card.classList.add("active");







        /*
        产品名称
        */


        let name =
            card.dataset.nameCn || "";



        if(card.dataset.nameEn){

            name += " | " + card.dataset.nameEn;

        }




        if(productInput){


            productInput.value=name;


            fireChange(productInput);


        }







        /*
        Size
        */


        let textarea =
            card.querySelector(".product-card__sizes");



        if(!textarea){

            return;

        }



        let sizes =
            textarea.value
            .trim()
            .split("\n");



        console.log(
            "尺寸:",
            sizes
        );







        // 删除旧option

        sizeSelect.innerHTML="";







        // 添加请选择

        let first =
            document.createElement("option");


        first.value="";

        first.textContent="Please Select";

        first.disabled=true;

        first.selected=true;


        sizeSelect.appendChild(first);







        // 添加尺寸

        sizes.forEach(function(size){


            size=size.trim();


            if(!size){

                return;

            }



            let option =
                document.createElement("option");


            option.value=size;

            option.textContent=size;


            sizeSelect.appendChild(option);



        });







        // 默认第一个

        if(sizeSelect.options.length>1){


            sizeSelect.selectedIndex=1;


            sizeSelect.value =
                sizeSelect.options[1].value;


        }






        fireChange(sizeSelect);



        console.log(
            "当前size:",
            sizeSelect.value
        );



    }






    cards.forEach(function(card){


        card.addEventListener(
            "click",
            function(){

                loadProduct(this);

            }
        );


    });





    // 默认

    loadProduct(cards[0]);



    return true;


}







// 等Formful加载

let timer=setInterval(function(){


    if(initProductSwitcher()){


        clearInterval(timer);


    }


},500);





})();